import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { TableCell } from "@mui/material";
import { toast } from "react-toastify";
import { useState } from "react";
import Loading from "src/Components/Loading/Loading";
import { useAppDispatch } from "src/App/hooks";
import {
  setStepCompetitionConfigFormModalOpen,
  setStepCompetitionConfigFormValues,
} from "src/Features/Step/stepSlice";
import { IStepCompetitionConfigTableReport } from "src/Interfaces/stepInterfaces";
import { deleteCompetitionConfig } from "src/Requests/stepRequests";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";

const AdditionalHeader = () => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">حذف</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IStepCompetitionConfigTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const editHandler = () => {
    dispatch(
      setStepCompetitionConfigFormValues({
        activeOrderPP: row.activeOrderPP,
        insCode: row.insCode,
        totalActiveOrder: row.totalActiveOrder,
        totalAmount: row.totalAmount,
      }),
    );
    dispatch(setStepCompetitionConfigFormModalOpen(true));
  };

  const deleteHandler = () => {
    setLoading(true);
    deleteCompetitionConfig(row.insCode)
      .then((resp) => {
        toast.success(resp.msg);
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        <div className="w-min mx-auto">
          <div
            onClick={editHandler}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <EditIcon className="text-sky-700 cursor-pointer" />
          </div>
        </div>
      </TableCell>
      <TableCell>
        {row.isDeletable && (
          <div className="w-min mx-auto" onClick={(e) => e.stopPropagation()}>
            {loading ? (
              <Loading size={16} className="!text-red-700" />
            ) : (
              <div
                onClick={deleteHandler}
                className="hover:bg-red-100 transition-all rounded p-1"
              >
                <DeleteIcon
                  fontSize="small"
                  className="text-red-700 cursor-pointer"
                />
              </div>
            )}
          </div>
        )}
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IStepCompetitionConfigTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
